import { render } from "./DocumentClassExportStates.vue?vue&type=template&id=58d510c2&scoped=true&ts=true"
import script from "./DocumentClassExportStates.vue?vue&type=script&lang=ts"
export * from "./DocumentClassExportStates.vue?vue&type=script&lang=ts"

import "./DocumentClassExportStates.vue?vue&type=style&index=0&id=58d510c2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58d510c2"]])

export default __exports__